<template>
  <v-sheet tag="section" :class="$vuetify.breakpoint.smAndDown? 'mb-8' : 'mb-15'">
    <v-row class="form-item-heading" :class="headingBgColor">
      <v-subheader class="text-subtitle-1 align-center"
                   :class="[headingTextColor ? `${headingTextColor}--text` : null, headingPadding, {'font-weight-bold': isHeadingTextBold}]">
        集荷先情報
        <small v-if="!isCharibon" :class="{'font-weight-bold': $vuetify.breakpoint.mdAndUp}">※ご本人様の身分証と一致する住所に限ります</small>
      </v-subheader>
    </v-row>
    <vb-company-name
      v-if="isCharibon"
      :form-items-setter="setBuyFormItems"
      :form-items-getter="{companyName: getBuyFormItems.companyName}"
    />
    <vb-names
      :form-items-setter="setBuyFormItems"
      :form-items-getter="{
            firstname: getBuyFormItems.firstname,
            lastname: getBuyFormItems.lastname,
            firstnameKatakana: getBuyFormItems.firstnameKatakana,
            lastnameKatakana: getBuyFormItems.lastnameKatakana
          }"
    />
    <vb-birth-date
      :form-items-setter="setBuyFormItems"
      :form-labels-setter="setBuyFormLabels"
      :form-labels-getter="{
              birthdateYear: getBuyFormLabels.birthdateYear,
              birthdateMonth: getBuyFormLabels.birthdateMonth,
              birthdateDay: getBuyFormLabels.birthdateDay
            }"
    />
    <pickup-address
      :form-items-setter="setBuyFormItems"
      :form-items-getter="{
              postcode: getBuyFormItems.postcode,
              addressPrefecture: getBuyFormItems.addressPrefecture,
              addressLocal1: getBuyFormItems.addressLocal1,
              addressLocal2: getBuyFormItems.addressLocal2,
              isAddressSameAsSuggested: getIsAddressSameAsSuggested,
              supportGroupId: getBuyFormItems.supportGroupId,
            }"
      :form-labels-setter="setBuyFormLabels"
    />
    <vb-job
      v-if="!isCharibon"
      :form-items-setter="setBuyFormItems"
      :form-items-getter="{
              jobCode: getBuyFormItems.jobCode,
              jobLabel: getBuyFormItems.jobLabel,
              }"
    />
    <vb-phone-number
      :form-items-setter="setBuyFormItems"
      :form-items-getter="{
              telephoneNumber1: getBuyFormItems.telephoneNumber1,
              telephoneNumber2: getBuyFormItems.telephoneNumber2,
              telephoneNumber3: getBuyFormItems.telephoneNumber3
            }"
    />
  </v-sheet>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import VbFormRow from "../../molecules/buy/vb-form-row.vue";
import VbCompanyName from "../../molecules/form/vb-company-name.vue";
import VbNames from "../../molecules/form/vb-names.vue";
import VbBirthDate from "../../molecules/form/vb-birth-date.vue";
import VbJob from "../../molecules/form/vb-job.vue";
import VbPhoneNumber from "../../molecules/form/vb-phone-number.vue";
import PickupAddress from "./pickup-address.vue";

export default {
  name: "pickup-information",
  components: {PickupAddress, VbPhoneNumber, VbJob, VbBirthDate, VbCompanyName, VbNames, VbFormRow},
  props: {
    headingBgColor: {type: String, default: null},
    headingTextColor: {type: String, default: null},
    headingPadding: {type: String, default: null},
    isHeadingTextBold: {type: Boolean, default: false},
  },
  methods: {
    ...mapActions({
      setBuyFormItems: 'buy/updateFormItems',
      setBuyFormLabels: 'buy/updateFormLabels',
    }),
  },
  computed: {
    ...mapGetters('buy', [
      'getFormItems',
      'getFormLabels',
    ]),
    ...mapGetters({
      getBuyFormItems: 'buy/getFormItems',
      getBuyFormLabels: 'buy/getFormLabels',
      getIsAddressSameAsSuggested: "buy/isAddressSameAsSuggested"
    }),
    isCharibon() {
      return this.$siteCode === VueConfig.siteCode.charibon;
    },
  }
}
</script>

<style scoped lang="scss">
.form-item-heading {
  white-space: nowrap;

  small {
    font-size: 10px;
    padding: 4px 0 0 5px;
  }
}

.caution-message {
  li {
    min-height: auto !important;
  }
}

.row {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

::v-deep {
  .v-input {
    input {
      background-color: transparent;
      border: 0 none;
    }
  }

  .v-radio {
    label {
      color: rgba(0, 0, 0, 0.87);
    }
  }

  .tooltip-link {
    pointer-events: initial;
  }

  .v-text-field--outlined {
    fieldset {
      border-width: 1px !important;
    }

    &.v-input--has-state {
      fieldset {
        border-color: #9c9b98 !important;
      }
    }
  }

  .input-bg-white {
    fieldset {
      background-color: #FFF !important;
    }

  }
}

</style>